module.exports = {
	"id": "KE",
	"name": "Kenya",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.001077,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.001077,
			"11": 0.019386,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.002154,
			"23": null,
			"24": 0.001077,
			"25": 0.002154,
			"26": 0.002154,
			"27": 0.004308,
			"28": 0.002154,
			"29": 0.002154,
			"30": 0.003231,
			"31": 0.012924,
			"32": 0.004308,
			"33": 0.011847,
			"34": 0.004308,
			"35": 0.001077,
			"36": 0.003231,
			"37": null,
			"38": 0.003231,
			"39": 0.005385,
			"40": 0.01077,
			"41": 0.002154,
			"42": 0.004308,
			"43": 0.023694,
			"44": 0.005385,
			"45": 0.009693,
			"46": 0.008616,
			"47": 0.008616,
			"48": 0.009693,
			"49": 0.176628,
			"50": 0.020463,
			"51": 0.077544,
			"52": 0.061389,
			"53": 2.812047,
			"54": 0.762516,
			"55": 0.024771,
			"56": 0.006462,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.004308,
			"4": 0.002154,
			"5": 0.002154,
			"6": null,
			"7": 0.002154,
			"8": 0.001077,
			"9": 0.002154,
			"10": 0.003231,
			"11": 0.004308,
			"12": 0.006462,
			"13": 0.003231,
			"14": 0.007539,
			"15": 0.005385,
			"16": 0.005385,
			"17": 0.003231,
			"18": 0.005385,
			"19": 0.005385,
			"20": 0.012924,
			"21": 0.003231,
			"22": 0.002154,
			"23": 0.003231,
			"24": 0.004308,
			"25": 0.004308,
			"26": 0.004308,
			"27": 0.004308,
			"28": 0.004308,
			"29": 0.011847,
			"30": 0.015078,
			"31": 0.011847,
			"32": 0.007539,
			"33": 0.012924,
			"34": 0.014001,
			"35": 0.015078,
			"36": 0.011847,
			"37": 0.016155,
			"38": 0.02154,
			"39": 0.018309,
			"40": 0.019386,
			"41": 0.022617,
			"42": 0.019386,
			"43": 0.113085,
			"44": 0.071082,
			"45": 0.065697,
			"46": 0.050619,
			"47": 0.291867,
			"48": 0.255249,
			"49": 2.234775,
			"50": 0.325254,
			"51": 0.003231,
			"52": 0.001077,
			"3.5": null,
			"3.6": 0.005385
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.007539,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.001077,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.004308,
			"29": 0.01077,
			"30": 0.006462,
			"31": 0.001077,
			"32": 0.009693,
			"33": 0.008616,
			"34": 0.022617,
			"35": 0.024771,
			"36": 0.011847,
			"37": 0.329562,
			"38": 0.003231,
			"39": 0.005385,
			"40": 0.14001,
			"41": 0.020463,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.002154,
			"12.1": 0.006462
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.002154,
			"6": null,
			"7": 0.003231,
			"8": 0.011847,
			"9": 0.015078,
			"10": 0.076467,
			"3.1": null,
			"3.2": null,
			"5.1": 0.004308,
			"6.1": 0.003231,
			"7.1": 0.003231,
			"9.1": 0.045234
		},
		"ios_saf": {
			"8": 0,
			"10": 0.250061150708,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00673885865945,
			"8.1-8.4": 0.0124497558285,
			"9.0-9.2": 0.00593933305579,
			"9.3": 0.0906129017485
		},
		"android": {
			"3": 0,
			"4": 0.0484139534884,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00605174418605,
			"4.1": 0.174636046512,
			"4.2-4.3": 0.436590116279,
			"4.4": 1.00113139535,
			"4.4.3-4.4.4": 1.00977674419
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.0361142419355,
			"9": 0.0109437096774,
			"10": 0.0164155645161,
			"11": 0.207930483871,
			"5.5": null
		},
		"op_mob": {
			"0": 5.26745249457,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.146318124849
		},
		"edge": {
			"12": 0.02154,
			"13": 0.038772,
			"14": 0.065697
		},
		"ie_mob": {
			"10": 0.190000901408,
			"11": 0.773575098592
		},
		"bb": {
			"7": 0.026766,
			"10": null
		},
		"samsung": {
			"0": 0.731604
		},
		"and_uc": {
			"0": 2.54277
		},
		"op_mini": {
			"0": 70.9674713806
		},
		"and_chr": {
			"0": 6.381831
		},
		"and_ff": {
			"0": 0.035688
		}
	},
	"total": 99.137601
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KE.json
 ** module id = 560
 ** module chunks = 0
 **/